import { render, staticRenderFns } from "./ListProduct.vue?vue&type=template&id=4445c298&lang=html"
import script from "./ListProduct.vue?vue&type=script&lang=js"
export * from "./ListProduct.vue?vue&type=script&lang=js"
import style0 from "./ListProduct.vue?vue&type=style&index=0&id=4445c298&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports